export default __webpack_public_path__ + "static/media/bvideo.f31180da.webm";